import { render, staticRenderFns } from "./collection.vue?vue&type=template&id=69ae567c&scoped=true&"
import script from "./collection.vue?vue&type=script&lang=js&"
export * from "./collection.vue?vue&type=script&lang=js&"
import style0 from "./collection.vue?vue&type=style&index=0&id=69ae567c&scoped=true&lang=stylus&"
import style1 from "./collection.vue?vue&type=style&index=1&id=69ae567c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ae567c",
  null
  
)

export default component.exports